/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Confirmation/view.blocks to change it.
import "DesignSystem/Fonts/Inter-300.css"
import "DesignSystem/Fonts/Inter-400.css"
import * as fromFlow from 'Simple/Flow'
import ButtonIconSquare from 'DesignSystem/ButtonIconSquare/index'
import Gotoform01 from 'DesignSystem/Svgs/Gotoform01/index'
import GreyfinchBird from 'DesignSystem/Svgs/GreyfinchBird/index'
import React from 'react'
import styles from './view.module.css'
import useIsBefore from 'Simple/hooks/useIsBefore'
import useIsHovered from 'Simple/hooks/useIsHovered'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function Confirmation({
  children,
  viewPath = "/App/Confirmation",
  patientUuid = "",
  title = "",
  medicalFormEnabled,
  goTo,
  subtitle = "",
  reset
  
}) {
  let isBefore = useIsBefore()
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
  return (<React.Fragment
>
<div
  data-testid="Confirmation.Vertical"
  data-view-path={viewPath}
 style={{'--o-1-Z2oI3vv': isBefore ? 0 : 1}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Confirmation.Vertical:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical1}`}
>
<div
  data-testid="Confirmation.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Confirmation.Vertical:2"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical2}`}
>
<span
  data-testid="Confirmation.Text"
  data-view-path={viewPath}
 className={`views-text patientUuid ${styles.Text}`}
>
{patientUuid}
</span>
<span
  data-testid="Confirmation.Text:1"
  data-view-path={viewPath}
 className={`views-text ${styles.Text1}`}
>
{title}
</span>
</div>
</div>
<span
  data-testid="Confirmation.Text:2"
  data-view-path={viewPath}
 className={`views-text ${styles.Text2}`}
>
{"We can't wait to see you! If you scheduled a virtual visit you will receive a link via email and/or SMS for your virtual call."}
</span>
<fromFlow.When is={medicalFormEnabled}>
<div
  data-testid="Confirmation.Vertical:3"
  data-view-path={viewPath}
 className="views-block"
>
<span
  data-testid="Confirmation.Text:3"
  data-view-path={viewPath}
 className={`views-text ${styles.Text3}`}
>
Just one more thing...
</span>
<a
 href={goTo} rel='noopener noreferrer' target='_blank'
  data-testid="Confirmation.Vertical:4"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical3}`}
>
<ButtonIconSquare
  viewPath={`${viewPath}/ButtonIconSquare`}
 height={340}
 marginTopText={30}
 text="Complete Patient's Medical Form"
 width={340}
>
{childProps => (
<Gotoform01
{...childProps}
  viewPath={`${viewPath}/Gotoform01`}
 height={240}
 width={340}
/>
)}
</ButtonIconSquare>
</a>
</div>
</fromFlow.When>
<fromFlow.When is={!medicalFormEnabled}>
<Gotoform01
  viewPath={`${viewPath}/Gotoform01`}
 height={240}
 marginTop={16}
 width={340}
/>
</fromFlow.When>
<div
  data-testid="Confirmation.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<span
  data-testid="Confirmation.Text:4"
  data-view-path={viewPath}
 className={`views-text ${styles.Text4}`}
>
{subtitle}
</span>
</div>
<fromFlow.When is={medicalFormEnabled}>
<div
  data-testid="Confirmation.Vertical:5"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical4}`}
>
<span
  data-testid="Confirmation.Text:5"
  data-view-path={viewPath}
 className={`views-text ${styles.Text5}`}
>
Please check your email and fill out your medical history form before the day of your appointment.
</span>
</div>
</fromFlow.When>
<button
  data-testid="Confirmation.Vertical:6"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={reset}
 className={`views-block ${styles.Vertical5}`}
>
<span
  data-testid="Confirmation.Text:6"
  data-view-path={viewPath}
 className={`views-text ${styles.Text6}`}
>
Schedule another appointment
</span>
</button>
<span
  data-testid="Confirmation.Text:7"
  data-view-path={viewPath}
 className={`views-text ${styles.Text7}`}
>
If you have any problems please contact the practice directly.
</span>
</div>
<div
  data-testid="Confirmation.Logo"
  data-view-path={viewPath}
 className={`views-block ${styles.Logo}`}
>
<GreyfinchBird
  viewPath={`${viewPath}/GreyfinchBird`}
 height={42}
 width={42}
/>
<span
  data-testid="Confirmation.Text:8"
  data-view-path={viewPath}
 className={`views-text ${styles.Text8}`}
>
Powered By Greyfinch
</span>
</div>
</div>
{children}
</React.Fragment>)
}